module.exports = __webpack_public_path__ + "img/technology-2.6bc61022.svg";